<div class="container-fluid widget-wrapper">
  <div class="row widget-header">
    <div class="col-lg-12">
      <h2>
        Authorized Seller (ads.txt)
        <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body p-0">
    <div class="col-lg-12">
      <domain-sov [os]="os" [data]="data" [isFollowing]="isFollowing" (anchorClick)="anchorClick.emit($event)"
        (toAppDiscovery)="toAppDiscovery.emit($event)"></domain-sov>
    </div>
  </div>
</div>
